<template>
	<component :is="tag" v-bind="containerProps" @click="onClick">
		<FileIcon
			v-if="media.fileIcon"
			class="media-file-icon"
			:icon="media.fileIcon"
		/>
		<div class="media-file-info">
			<div class="media-file-title" :class="{ 'meetings-title': meetings }">
				<div
					class="media-file-title-main"
					v-safe-html="titleNoExt"
					data-private
				/>
				<div v-text="media.extension" />
			</div>
			<div class="media-file-size" v-text="media.size" />
		</div>
		<div v-if="loading" class="media-file-preview-wrapper">
			<IndeterminateLoader class="media-file-preview-loader" />
		</div>
	</component>
</template>

<script setup>
import { computed } from 'vue'
import FileIcon from '@/components/common/FileIcon'
import IndeterminateLoader from '@/components/IndeterminateLoader'
import { useMediaModal } from '@/components/common'

const modal = useMediaModal()

const props = defineProps({
	media: Object,
	disabled: { type: Boolean, default: null },
	loading: { type: Boolean, default: null },
	noDownload: { type: Boolean, default: null },
	meetings: { type: Boolean, default: null },
})

const tag = computed(() => (props.noDownload ? 'div' : 'a'))
const titleNoExt = computed(() =>
	props.media.title.replace(`.${props.media.extension}`, '.')
)
const containerProps = computed(() => {
	if (props.noDownload)
		return {
			ref: 'attachment',
			class: { 'media-file-container': true, disabled: props.disabled },
		}
	return {
		download: true,
		href: props.media.mediaUrl,
		target: '_blank',
		class: {
			'media-file-container': true,
			disabled: props.disabled,
			pointer: true,
		},
	}
})

function onClick(e) {
	if (props.media.isPDF) {
		e.preventDefault()
		modal.mediaItems([props.media])
	}
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.media-file-container {
	@include flex(10px);
	text-decoration: none;
	color: inherit;
	width: max-content;
	position: relative;
	border-radius: 6px;
	border: 1px solid var(--neutral-200);
	padding: 8px 16px 8px 12px;
	&.disabled {
		pointer-events: none;
	}
	.media-file-info {
		height: max-content;
		flex-grow: 1;
		width: 100%;
		width: calc(100% - 56px);
		.media-file-title {
			width: 100%;
			max-width: max-content;
			@include flex(0);
			font-size: 14px;
			color: var(--neutral-800);
			@include fontFamily(500);
			.media-file-title-main {
				@include ellipsis;
				flex-grow: 1;
			}
		}
		.media-file-size {
			font-size: 12px;
			color: var(--neutral-500);
		}
	}
	.media-file-icon {
		font-size: 39px;
		text-decoration: none;
	}
}

.meetings-title {
	color: #fff !important;
}

.media-file-preview-wrapper {
	position: absolute;
	right: 1px;
	bottom: 1px;
	height: 15px;
	width: 15px;
}
</style>
